import * as React from "react";

const ThumbsUp = (props: { color?: string; isActive?: boolean }) => {
    if (props.isActive) {
        return (
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_666_1321)">
                    <path
                        d="M3.4023 16H0.689655C0.312644 16 0 15.6855 0 15.3064V5.59538C0 5.21618 0.312644 4.90173 0.689655 4.90173H3.4023V16Z"
                        fill={props.color}
                    />
                    <path
                        d="M4.81842 14.6035C4.81842 15.3711 5.43451 16 6.19773 16H11.8161C12.6437 16 13.4529 15.4636 13.738 14.7329L15.9449 9.27629L16 9.01733V6.98265C16 5.83583 15.0713 4.90172 13.9311 4.90172H10.3173L10.8414 2.86704C10.9885 2.11791 10.777 1.35028 10.2529 0.823111L9.51727 0.175712C9.24141 -0.0647504 8.83681 -0.0555019 8.57934 0.203458L5.20463 3.53294C4.93796 3.7919 4.79083 4.15259 4.79083 4.53178C4.80003 6.35375 4.83681 11.9769 4.81842 14.6127V14.6035Z"
                        fill={props.color}
                    />
                </g>
                <defs>
                    <clipPath id="clip0_666_1321">
                        <rect width="16" height="16" fill="white" />
                    </clipPath>
                </defs>
            </svg>
        );
    }
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M13.931 4.89968H10.3172L10.8414 2.865C10.9885 2.11586 10.777 1.34823 10.2529 0.821066L9.51724 0.173667C9.25058 -0.0667951 8.83678 -0.0575466 8.57931 0.201413L3.81609 4.89968H0.689655C0.312644 4.89968 0 5.21413 0 5.59332V15.3043C0 15.6835 0.312644 15.9979 0.689655 15.9979H11.8161C12.6437 15.9979 13.4529 15.4615 13.7379 14.7309L15.9448 9.27425C15.9816 9.19101 16 9.09852 16 9.01529V6.9806C16 5.85228 15.0529 4.89968 13.931 4.89968ZM1.37931 6.28696H3.4023V14.6107H1.37931V6.28696ZM14.6207 8.87656L12.4598 14.213C12.3862 14.3979 12.092 14.6107 11.8161 14.6107H4.78161V5.88003L9.08506 1.63494L9.30575 1.82916C9.50805 2.03263 9.52644 2.36557 9.48965 2.55055L8.75402 5.4176C8.69885 5.62107 8.75402 5.84303 8.87356 6.01875C9.0023 6.18523 9.2046 6.28696 9.41609 6.28696H13.9218C14.2805 6.28696 14.6115 6.61991 14.6115 6.9806V8.87656H14.6207Z"
                fill={props.color}
            />
        </svg>
    );
};

export default ThumbsUp;
